import { Routes, Route } from 'react-router-dom'
import { Briefcase, FileText, Clock, User } from 'lucide-react'
import BottomNav from '../components/navigation/BottomNav.tsx'
import AppHeader from '../components/navigation/AppHeader.tsx'
import JobsPage from '../pages/locum/JobsPage.tsx'
import ApplicationsPage from '../pages/locum/ApplicationsPage.tsx'
import TimesheetsPage from '../pages/locum/TimesheetsPage.tsx'
import ProfilePage from '../pages/locum/ProfilePage.tsx'

const locumTabs = [
  {
    id: 'jobs',
    label: 'Jobs',
    icon: Briefcase,
    path: '/locum/jobs'
  },
  {
    id: 'applications',
    label: 'Applications',
    icon: FileText,
    path: '/locum/applications'
  },
  {
    id: 'timesheets',
    label: 'Timesheets',
    icon: Clock,
    path: '/locum/timesheets'
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: User,
    path: '/locum/profile'
  }
]

export default function LocumLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <AppHeader />

      <main className="flex-1 pb-16">
        <Routes>
          <Route path="/locum/jobs" element={<JobsPage />} />
          <Route path="/locum/applications" element={<ApplicationsPage />} />
          <Route path="/locum/timesheets" element={<TimesheetsPage />} />
          <Route path="/locum/profile" element={<ProfilePage />} />
          <Route path="/" element={<JobsPage />} />
        </Routes>
      </main>

      <BottomNav tabs={locumTabs} />
    </div>
  )
}
